export default "__VITE_ASSET__CZvU8l4W__"